import { render, staticRenderFns } from "./HuongDanSuDung.vue?vue&type=template&id=42165fc2&scoped=true&"
import script from "./HuongDanSuDung.vue?vue&type=script&lang=js&"
export * from "./HuongDanSuDung.vue?vue&type=script&lang=js&"
import style0 from "./HuongDanSuDung.vue?vue&type=style&index=0&id=42165fc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42165fc2",
  null
  
)

export default component.exports